var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVertical = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1 1021",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1021
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,125.7v-1.4h1v1.4H0ZM0,121.4v-1.4h1v1.4H0ZM0,141.1v-1.4h1v1.4H0ZM0,196.2v-1.4h1v1.4H0ZM0,136.5v-1.4h1v1.4H0ZM0,44.3v-1.4h1v1.4H0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,365.7v-1.4h1v1.4H0ZM0,361.4v-1.4h1v1.4H0ZM0,381.1v-1.4h1v1.4H0ZM0,436.2v-1.4h1v1.4H0ZM0,376.5v-1.4h1v1.4H0ZM0,284.3v-1.4h1v1.4H0Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,573.5v-1.4h1v1.4H0ZM0,569.1v-1.4h1v1.4H0ZM0,588.9v-1.4h1v1.4H0ZM0,643.9v-1.4h1v1.4H0ZM0,584.2v-1.4h1v1.4H0ZM0,492.1v-1.4h1v1.4H0Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,705.7v-1.4h1v1.4H0ZM0,701.4v-1.4h1v1.4H0ZM0,721.1v-1.4h1v1.4H0ZM0,776.2v-1.4h1v1.4H0ZM0,716.5v-1.4h1v1.4H0ZM0,624.3v-1.4h1v1.4H0Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,893.4v1.4H0v-1.4h1ZM1,897.7v1.4H0v-1.4h1ZM1,878v1.4H0v-1.4h1ZM1,822.9v1.4H0v-1.4h1ZM1,882.6v1.4H0v-1.4h1ZM1,974.7v1.4H0v-1.4h1Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVertical);
export default ForwardRef;